// extracted by mini-css-extract-plugin
export default {"wrapper":"BaseLayout_wrapper__VmP9b"};